<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            基本信息
          </div>
          <el-row class="invice-info">
            <el-col :span="8">
              <span class="label">结算单来源：</span>
              <span class="value">
              <span v-if="Number(form.sourceType) === 1">平台结算</span>
              <span v-if="Number(form.sourceType) === 2">第三方结算</span>
            </span>
            </el-col>
            <el-col :span="8">
              <span class="label">服务商：</span>
              <span class="value">{{ form.companyName }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">创建人：</span>
              <span class="value">{{ form.creator || "-" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">结算单号：</span>
              <span class="value">{{ form.settlementNo || "-" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">不可退定金：</span>
              <span class="value" style="color: #0a65f0">{{ numberToThousand(form.deposit)}}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">技术服务费：</span>
              <span class="value" style="color: #0a65f0">{{ numberToThousand(form.technicalFee)}}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">服务费：</span>
              <span class="value" style="color: #0a65f0">{{ numberToThousand(form.managerFee)}}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">结算金额：</span>
              <span class="value" style="color: #0a65f0">{{ numberToThousand(form.settleAmount)}}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">代收金额：</span>
              <span class="value " style="color: #0a65f0">{{ numberToThousand(form.agencyFee) || "-" }}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">账单运费：</span>
              <span class="value" style="color: #0a65f0">{{ numberToThousand(form.fee) || "-" }}元</span>
            </el-col>
            <el-col :span="8" v-if="form.settlementStatus === 0">
              <span class="label">结算状态：</span>
              <span class="value">
                <el-tag type="danger">未结算</el-tag>
              </span>
            </el-col>
            <el-col :span="16" >
              <span class="label">结算周期：</span>
              <span class="value" v-if="form.sourceType === 2">{{ form.startTime }} - {{form.endTime}}</span>
              <span class="value" v-if="form.sourceType === 1">手动结算</span>
            </el-col>
          </el-row>
          <el-row class="invice-info" v-if="form.settlementStatus === 1">
            <el-col :span="8">
              <span class="label">结算状态：</span>
              <span class="value">
                <el-tag>已结算</el-tag>
              </span>
            </el-col>
            <el-col :span="8">
              <span class="label">结算时间：</span>
              <span class="value">{{ form.settleTime || "-" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">结算人：</span>
              <span class="value">{{ form.settleUserName || "-" }}</span>
            </el-col>
          </el-row>
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            订单信息
          </div>
          <div class="related-orders">
            <custom-table  :data="tableData"
                           :column="tableColumn"
                           :showPagination="true"
                           :total="tableOptions.total"
                           :loading="tableOptions.loading"
                           :page="tableOptions.pageNumber"
                           :size="tableOptions.pageSize"
                           :selection="false"
                           @pagination="handleSizeChange">
              <template v-slot:orderNo="{ row }">
                <span class="cursor color1966ff" @click="handleDetail(row)">{{row.orderNo}}</span>
              </template>
              <template v-slot:startProvinceName="{ row }">
                <div>起点：{{row.startProvinceName}}{{row.startCityName}}{{row.startDistrictName}}</div>
                <div>终点：{{row.endProvinceName}}{{row.endCityName}}{{row.endDistrictName}}</div>
              </template>
            </custom-table>
          </div>

        </div>
      </template>
    </DialogContainer>
    <detail ref="detail"></detail>
  </div>


</template>

<script>
import {numberToThousand} from "@/utils/tool"
import detail from "@/views/OrderManagement/detail.vue";
import DialogContainer from "@/components/Dialog.vue";
import {reconciliationOrders, reconciliationOrderDetail} from "./api";
import CustomTable from "@/components/CustomTable.vue";
import tableMixin from "@/mixin/tableMixin";
export default {
  name: "Detail",
  mixins: [tableMixin],
  components: {
    CustomTable,
    detail,
    DialogContainer,
  },
  data() {
    return {
      getTableMethod: reconciliationOrders,
      isImmediatelyGetData: false,
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "结算单详情",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.tableData = [];
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {},
      searchForm: {
        "billId": "",
        "orderNo": ""
      },
      tableColumn: [
        {
          label: "订单编号",
          prop: "orderNo",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "第三方订单号",
          prop: "sourceOrderNo",
          align: "left",
          show: true,
        }, {
          label: "路线",
          prop: "startProvinceName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "账单运费",
          prop: "payableFee",
          width: "100px",
          align: "left",
          show: true,
        },
        {
          label: "结算金额",
          prop: "settleAmount",
          width: "100px",
          align: "left",
          show: true,
        },
        {
          label: "代收金额",
          prop: "agencyFee",
          width: "100px",
          align: "left",
          show: true,
        },


      ],
    };
  },
  mounted() {},
  methods: {
    numberToThousand,
    init(row) {
      this.searchForm.billId = row.billId;
      this.getDetail(row.billId)
      this.getTableData()
      this.dialogObj.show = true;
    },
    handleDetail(row) {
      this.$refs.detail.init(row);
    },
    getDetail(billId) {
      reconciliationOrderDetail({billId: billId})
          .then((res) => {
            this.dialogObj.btnLoading = false;
            if (res.code === 200) {
              this.form = res.data;
            }
          })
          .catch((e) => {
            this.dialogObj.btnLoading = false;
          });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const fileIds = this.form.fileIds
              .map(item => item.fileId);
          const par = {
            billId: this.form.billId,
            fileIds: fileIds,
          };
          handleInvoice(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("处理成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .related-orders {
    background: #f7f8fb;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
  }
}
</style>
